import ReactTable from "./reactTable";
export default ReactTable;
